import React, { ReactElement, ReactNode, useRef, useState } from 'react';

interface ChildrenLockProps {
  children: ReactNode;
}

interface LockProps {
  component: ReactElement | null;
}

export const ChildrenLock: React.FC<ChildrenLockProps> = ({ children }) => {
  const elements = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return <Lock component={child} />;
    }
    return null;
  });

  return <>{elements}</>;
};

const Lock: React.FC<LockProps> = ({ component }) => {
  const ref = useRef<HTMLDivElement>();
  const [frozenWidth, setFrozenWidth] = useState<number | null>(null);

  React.useLayoutEffect(() => {
    if (!frozenWidth && ref.current) {
      const { width } = ref.current.getBoundingClientRect?.() || {};
      width && setFrozenWidth(width);
    }
  }, [frozenWidth]);

  const frozen = React.useMemo(() => {
    if (!component) {
      return null;
    }
    return frozenWidth
      ? React.cloneElement(component, { style: { width: frozenWidth } })
      : React.cloneElement(component, { ref });
  }, [component, frozenWidth]);

  return frozen;
};
